import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0.001, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
};

export const Overline = ({ children, className = "", light = false }) => (
  <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] ${light ? "text-gold" : "text-brown"} ${className}`}>{children}</p>
);
